import { render, staticRenderFns } from "./MessageTranslate.vue?vue&type=template&id=d741e200&scoped=true"
import script from "./MessageTranslate.vue?vue&type=script&lang=js"
export * from "./MessageTranslate.vue?vue&type=script&lang=js"
import style0 from "./MessageTranslate.vue?vue&type=style&index=0&id=d741e200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d741e200",
  null
  
)

export default component.exports